export default {
  AUTH_TOKEN_KEY: "user:auth_token_v3.0",
  AUTH_MODULE: "user:module",
  USER_CURRENT: "user:current",
  COOKIE_CONSENT: "user:cookie_consent",
  SMART_TOPICS_GRADES_SELECT: "smart_topics::grades::select",
  TEACHER_FILTERED_JOURNALS: "teacher:dashboard:filtered_journals",
  STUDENT_FILTERED_SUBJECTS: "student:dashboard:filtered_subjects",
  TEACHER_COLLAPSED_JOURNALS: "teacher:dashboard:collapsed_journals",
  STUDENT_COLLAPSED_LESSONS: "student:dashboard:collapsed_lessons",
  SMART_TOPICS_SUBJECT_GRADE_FILTER: "smart_topics:subject_grade_filter",
  QUESTION_BANK_SUBJECT_GRADE_FILTER: "question_bank:subject_grade_filter",
  ALL_MATERIALS_SUBJECT_GRADE_FILTER: "all_materials:subject_grade_filter",
  QUESTION_BANK_SELECTED_SUBJECT: "question_bank:selected_subject",
  ALL_MATERIALS_SELECTED_SUBJECT: "all_materials:selected_subject",
  MY_QUIZZES_SELECTED_SUBJECT: "my_quizzes:selected_subject",
  SOMA_QUIZZES_SELECTED_SUBJECT: "soma_quizzes:selected_subject",
  TEACHER_TESTS_OVERVIEW_FILTERED_JOURNALS: "teacher_tests_overview:filtered_journals",
  OVERVIEW_FILTERED_JOURNALS: "overview:filtered_journals",
  STUDENT_TESTS_OVERVIEW_FILTERED_SUBJECTS: "student_tests_overview:filtered_subjects",
  REPEATABLES: "repeatables",
  PRODUCT_FILTERS_PREFIX: "product:filters",
  MY_JOURNALS_COLLAPSED: "my_journals:journals_collapsed",
  MY_JOURNALS_FILTERS: "my_journals:filters",
  STUDENT_JOURNALS_COLLAPSED: "my_journals:student:collapsed",
  STUDENT_JOURNALS_COLLAPSED_TESTS: "my_journals:student:collapsed:tests",
  STUDENT_JOURNALS_FILTERS: "my_journals:student:filters",
  HOMEWORK_BUTTON_PATHS: [
    "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()",
    "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()/contents",
    "/e-gramatas/:slug/pdf",
    "/darba-lapas/:slug/pdf",
    "/video/:slug"
  ],
  TEACHER_COLLAPSED_WORKSHEET_JOURNALS: "teacher:worksheet:collapsed_journals",
  TEACHER_FILTERED_WORKSHEET_JOURNALS: "teacher:worksheet:filtered_journals",
  STUDENT_COLLAPSED_WORKSHEET_JOURNALS: "student:worksheet:collapsed_journals",
  STUDENT_FILTERED_WORKSHEET_SUBJECTS: "student:worksheet:filtered_subjects",
  TESTS_AND_QUESTIONS_SUBJECT_GRADE_FILTER: "tests_and_questions:subject_grade_filter",
  STUDENT_WHEEL_JOURNAL_ID: "student_wheel:journal_id",
  NOTICES: "notices",
}
